"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUtilityClasses = exports.funnelSectionClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("@mui/utils/generateUtilityClass"));
var _generateUtilityClasses = _interopRequireDefault(require("@mui/utils/generateUtilityClasses"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
function getFunnelSectionUtilityClass(slot) {
  return (0, _generateUtilityClass.default)('MuiFunnelSection', slot);
}
const useUtilityClasses = props => {
  const {
    classes,
    seriesId,
    variant
  } = props;
  const slots = {
    root: ['root', `series-${seriesId}`],
    highlighted: ['highlighted'],
    faded: ['faded'],
    outlined: variant === 'outlined' ? ['outlined'] : [],
    filled: variant === 'filled' ? ['filled'] : [],
    label: ['label']
  };
  return (0, _composeClasses.default)(slots, getFunnelSectionUtilityClass, classes);
};
exports.useUtilityClasses = useUtilityClasses;
const funnelSectionClasses = exports.funnelSectionClasses = (0, _generateUtilityClasses.default)('MuiFunnelSection', ['root', 'highlighted', 'faded', 'filled', 'outlined', 'label', 'series']);